import React from "react";

import { Container, Navbar, Nav, Button, Form } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap'
import Image from "../images/logo_afp.png";
import { AuthenticatedTemplate, useMsal } from "@azure/msal-react";

function NavBar() {
    const { instance } = useMsal();

    return (
        <div>
            <Navbar className="navBarCustom" bg="white" expand="lg" sticky="top" >
                <Container>
                    <LinkContainer to='/'>
                        <Navbar.Brand >
                            <img
                                alt="AFP Capital"
                                src={Image}
                                style={{ height: '36px', width: 'auto' }}
                                className="d-inline-block align-top"
                            />
                        </Navbar.Brand>
                    </LinkContainer>
                    <Nav className="me-auto">
                        <LinkContainer to='/'>
                            <Nav.Link className="fw-semibold">Inicio</Nav.Link>
                        </LinkContainer>
                    </Nav>
                    <AuthenticatedTemplate>
                        <Form className="d-flex">
                            <Button variant="outline-danger" onClick={() => instance.logoutPopup({ postLogoutRedirectUri: "/", mainWindowRedirectUri: "/" })}>Cerrar Sesión</Button>
                        </Form>
                    </AuthenticatedTemplate>
                </Container>
            </Navbar>
        </div>
    )
}

export default NavBar